import { atom } from "jotai";
import { DataColumn } from "../config/dataInterface";

export interface TenantPlan {
  plan_id: string;
  plan_name: string;
  max_partners: number;
  max_et_sites: number;
  has_payment: boolean;
  has_ai_analysis: boolean;
  current_partners: number;
  current_et_sites: number;
  monthly_price: number;
}

// 読み込み中かどうか
const isLoading = atom<boolean>(false);

// ログインしているかどうか
const isLogin = atom<boolean>(false);

// ログインユーザー情報
export interface loginUserDifine {
  idToken: string;
  username: string;
  authority: string;
  db_authority: string;
  company: string;
  title: string;
  color: string;
}
const loginUser = atom<loginUserDifine>();

// メニュー表示
const switchMenu = atom<boolean>(false);

// パス
const pathname = atom<string>("");

// スマートフォン表示
const isSmartPhone = atom<boolean>(false);

// カラム設定
// エントリー一覧
const contractScreenColumn = atom<DataColumn[]>([]);

// トスアップ一覧
const tossUpScreenColumn = atom<DataColumn[]>([]);

// ランキング一覧
const accountRunkingScreenColumn = atom<DataColumn[]>([]);

// テナントサブスクリプションプラン情報
const tenantPlanAtom = atom<TenantPlan | null>(null);

// サンプル質問（ページ名→質問配列の辞書）
const sampleQuestionsAtom = atom<Record<string, string[]>>({});

// Stage2 (DB getProfile) 完了フラグ
const profileLoaded = atom<boolean>(false);

// AIチャットパネル開閉状態（AppShell L4 margin-right配線用）
const aiChatOpen = atom<boolean>(false);

// 詳細ページ用ブレッドクラム（nullのとき通常タイトル表示）
const detailBreadcrumb = atom<{ crumb: string; title: string } | null>(null);

// ヘッダー作成ボタン注入（画面がatomにラベル+ハンドラを登録→AppShellが描画→unmountでクリア）
export interface HeaderCreateAction {
  label: string;
  handler: () => void;
  testId?: string;
}
const headerCreateAction = atom<HeaderCreateAction | null>(null);

// ヘッダー作成ボタン複数注入（M5: Product等で2本独立ボタンが必要な場合）
// 非nullのとき headerCreateAction より優先して複数ボタン描画
const headerCreateActions = atom<HeaderCreateAction[] | null>(null);

// 保存成功トースト（rev incrementで連続保存の再トリガーを保証）
const toastAtom = atom<{ message: string; rev: number } | null>(null);

// 一覧スクロール位置・行ID保存（pathname-keyed・一覧→詳細→一覧の往復で位置を復元）
export interface ListScrollState {
  top: number;
  left: number;
  rowId: string | null;
}
const listScrollByRoute = atom<Record<string, ListScrollState>>({});

// cmd-po_1243(R40): SP時のみ、fixed化したページタブ帯の実高（PageTabsがoffsetHeightで実測して書込・アンマウントで0に戻す）。
// TableTopBarが自身のfixed top を calc(--header-h + この値px) にしてタブ帯の裏に回らないようにする。PCでは常に0。
const spPageTabsHeight = atom<number>(0);

export const AppAtoms = {
  isLoading,
  isLogin,
  loginUser,
  switchMenu,
  pathname,
  isSmartPhone,
  contractScreenColumn,
  tossUpScreenColumn,
  accountRunkingScreenColumn,
  tenantPlanAtom,
  sampleQuestionsAtom,
  profileLoaded,
  aiChatOpen,
  detailBreadcrumb,
  headerCreateAction,
  headerCreateActions,
  toastAtom,
  listScrollByRoute,
  spPageTabsHeight,
};
